module.exports = __webpack_public_path__ + "static/media/ConfettiEffect.d.ts.3b05a99b.map";